import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { Action, Layout, Message } from './styled';

interface IDeliveryBannerProps {
  message: string;
  onClick: () => void;
  position?: 'absolute' | 'relative';
}

const DeliveryBanner = ({ message, onClick, position }: IDeliveryBannerProps) => {
  const { formatMessage } = useIntl();

  return (
    <Layout position={position} data-testid="delivery-banner">
      <Message>{message}</Message>
      <Action onClick={onClick}>{formatMessage(messages.track)}</Action>
    </Layout>
  );
};

export default DeliveryBanner;

const messages = defineMessages({
  track: {
    id: 'track',
    defaultMessage: 'Track',
    description: 'Track button text for the delivery banner'
  }
});
